import { ErrorAlert, useObservedFailedQueries } from '@repo/ui'
import { useTranslation } from 'react-i18next'
import useOnlineDetection from '@/features/offline/hooks/useOnlineDetection'

export interface FailedQueryNotificationsProps {
  'data-testid': string
}

export default function FailedQueryNotifications({
  'data-testid': testId
}: Readonly<FailedQueryNotificationsProps>) {
  const { t } = useTranslation('common')
  const hasFailedQueries = useObservedFailedQueries()
  const isOnline = useOnlineDetection()

  if (isOnline && hasFailedQueries) {
    return (
      <ErrorAlert data-testid={testId} className="mt-1">
        {t('failedQueryNotification')}
      </ErrorAlert>
    )
  }
  return null
}
